module.exports = __webpack_public_path__ + "static/media/37F55A_2_0.7bc553c1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/37F55A_2_0.woff
// module id = 739
// module chunks = 0